<div class="modal-header">
    <cm-profile-avatar
        class="header-avatar"
        [imageUrl]="requestedByImage"
        placeholder="/assets/images/user-icon-colored.svg"
    ></cm-profile-avatar>
    <div class="header-text">
        <h2 class="modal-title">Provide access to the credential</h2>
        <div class="modal-subtitle">
            {{ requestedBy }} has requested access. In case you accept the request he will have access to credential
            status, attachemnts, and will be able complete steps.
        </div>
    </div>
</div>
<div class="modal-body">
    <div class="agreement-text">{{ agreement_text }}</div>
    <cm-signature #sign class="signature"></cm-signature>
    <cm-checkbox [(ngModel)]="termsAccepted" class="accept-checkbox"
        >I've read and accept the agreement document</cm-checkbox
    >
    <p [hidden]="!error" class="error">{{ error }}</p>
</div>
<div class="modal-footer">
    <div class="btn btn-default" (click)="modalService.dismiss()">Close</div>
    <div class="btn btn-primary" (click)="acceptRequest(sign)">Confirm</div>
</div>
